import React from 'react';
import { useTranslation } from 'react-i18next';
import { ApiButton, Button, Dialog, DialogActions, DialogContent, DialogTitle } from 'web-library';
import { MutationStatus } from 'react-query';
import {
  SubjectDetails,
  ViewSelectedSubjectsResponseBody,
} from '../../../api/candidate/exam/model';

export interface DeleteSubjectActionProps {
  onConfirm: (applicationUuid: string, subjectUuid: string, subjectDetails: SubjectDetails) => void;
  onClose: () => void;
  apiStatus: MutationStatus;
}

export interface DeleteSubjectModalProps {
  modelOpen: boolean;
  subjectDetails: ViewSelectedSubjectsResponseBody;
  applicationUuid: string;
  deleteSubjectAction: DeleteSubjectActionProps;
}

const DeleteSubjectModal = ({
  modelOpen,
  subjectDetails,
  applicationUuid,
  deleteSubjectAction,
}: DeleteSubjectModalProps) => {
  const { t } = useTranslation();
  const { subjectName, subjectCode, subjectLevel, examRegistrationDetailUuid } = subjectDetails;
  return (
    <Dialog open={modelOpen} maxWidth="sm">
      <DialogTitle>
        {t('exam->>ViewSelectedSubjects.RemoveFromSelectedSubjects', {
          subjectNameSubjectCode: `${subjectName} (${subjectCode})`,
        })}
      </DialogTitle>
      <DialogContent>
        {t('exam->>ViewSelectedSubjects.RemoveFromSelectedSubjectsQuestion')}
      </DialogContent>
      <DialogActions>
        <Button
          type="button"
          variant="text"
          size="small"
          color="secondary"
          onClick={deleteSubjectAction.onClose}
        >
          {t('exam->>ViewSelectedSubjects.Cancel')}
        </Button>
        <ApiButton
          status={deleteSubjectAction.apiStatus}
          type="button"
          color="secondary"
          size="small"
          onClick={() =>
            deleteSubjectAction.onConfirm(applicationUuid, examRegistrationDetailUuid || '', {
              subjectName,
              subjectCode,
              subjectLevel,
            })
          }
        >
          {t('exam->>ViewSelectedSubjects.Proceed')}
        </ApiButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSubjectModal;
